export default __webpack_public_path__ + "static/media/geo.d0ccb85b.svg";